import { render } from "./TagView.vue?vue&type=template&id=bdd43682&scoped=true"
import script from "./TagView.vue?vue&type=script&lang=js"
export * from "./TagView.vue?vue&type=script&lang=js"

import "./TagView.vue?vue&type=style&index=0&id=bdd43682&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdd43682"]])

export default __exports__